import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import { useRouter } from 'vue-router';
import { LocationMarkerIcon, EyeIcon } from '@heroicons/vue/solid';
import { NumberModel } from '@/types';
import { applyPhoneMask } from '@/utils/number';
import SVGWhatsApp from '@/components/svg/SVGWhatsApp.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'WhatsappCodeNumberListItem',
  props: {
    modelValue: {
        type: Object as PropType<NumberModel>,
        required: true,
    },
},
  setup(__props, { expose: __expose }) {
  __expose();



const router = useRouter();

const handleMonitorClick = () => {
    router.push({
        name: 'MonitorWhatsappCodeNumber',
        params: {
            id: __props.modelValue.id,
        },
    });
};

const __returned__ = { router, handleMonitorClick, get LocationMarkerIcon() { return LocationMarkerIcon }, get EyeIcon() { return EyeIcon }, get applyPhoneMask() { return applyPhoneMask }, SVGWhatsApp }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})